<template>
  <div class="visit-claims">
    <v-row no-gutters>
      <v-col cols="6" class="margin-auto">
        <h2 class="margin-auto color-custom-blue font-weight-600">Claims</h2>
      </v-col>
      <v-col cols="6">
        <!-- No buttons -->
      </v-col>
    </v-row>
    <v-row class="customer-detail custom-border-to">
      <v-col md="12" sm="12" class="pt-0">
        <v-skeleton-loader
          class="custom-skeleton"
          v-if="loading"
          type="table-tbody"
        >
        </v-skeleton-loader>
        <v-simple-table v-else class="simple-table">
          <template v-slot:default>
            <thead>
              <tr style="background-color: #f3f6f9; color: #24326d">
                <th class="simple-table-th" width="150">Claim #</th>
                <th class="simple-table-th">Title</th>
                <th class="simple-table-th" width="120">Employee</th>
                <th class="simple-table-th" width="150">Payment Mode</th>
                <th class="simple-table-th" width="120">Amount</th>
                <th class="simple-table-th" width="100">Currency</th>
                <th class="simple-table-th" width="150">Category</th>
                <th class="simple-table-th" width="120">Claim Date</th>
                <th class="simple-table-th" width="100">Status</th>
                <!-- <th
                  class="simple-table-th"
                  width="100"
                >
                  Type
                </th> -->
                <th class="simple-table-th" width="120">Created On</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, index) in claims"
                :key="data.id || index"
                :class="{
                  'custom-border-top': index == 0,
                  'orange_lighten-5': index % 2 == 0,
                }"
                @click="
                  $router.push(
                    getDefaultRoute('claim.detail', { params: { id: data.id } })
                  )
                "
                style="cursor: pointer"
              >
                <!-- Claim # Column -->
                <td class="font-size-14 font-weight-500">
                  <Barcode :barcode="data.claim_barcode"></Barcode>
                </td>

                <!-- Title Column -->
                <td class="font-size-14 font-weight-500">
                  <template v-if="data && data.title">
                    {{ data.title }}
                  </template>
                  <em v-else class="text-muted">no title</em>
                </td>
                <td class="font-size-14 font-weight-500">
                  <template v-if="data && data.engineer_relation.display_name">
                    {{ data.engineer_relation.display_name }}
                  </template>
                  <em v-else class="text-muted">no employee</em>
                </td>
                <td class="font-size-14 font-weight-500">
                  <v-chip
                    small
                    class="py-0 d-inline-flex align-center"
                    outlined
                    color="green"
                    label
                  >
                    <b>
                      <v-icon small class="mr-1"
                        >mdi-credit-card-outline</v-icon
                      >
                      {{ data.payment_mode_name }}
                    </b>
                  </v-chip>
                </td>
                <!-- Amount Column -->
                <td class="font-size-14 font-weight-500">
                  <v-chip small class="py-0" color="green" label>
                    <span class="text-white">
                      <b>{{ data.amount }}</b>
                    </span>
                  </v-chip>
                </td>

                <!-- Currency Column -->
                <td class="font-size-14 font-weight-500">
                  <v-chip small class="py-0" color="green" label>
                    <span class="text-white">
                      <b>{{ data.currency_name }}</b>
                    </span>
                  </v-chip>
                </td>

                <!-- Company Name Column -->
                <td class="font-size-14 font-weight-500">
                  <template v-if="data && data.expense_category_name">
                    <v-chip
                      label
                      outlined
                      small
                      :color="data.expense_category_color"
                      class="d-flex align-center"
                    >
                      {{ data.expense_category_name }}
                    </v-chip>
                  </template>
                  <em v-else class="text-muted">no category</em>
                </td>

                <!-- Expense Date Column -->
                <td class="font-size-14 font-weight-500">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        v-if="data.expense_date"
                        class="mx-2 mb-0 custom-grey-border d-table-caption"
                        color="cyan darken-1"
                        text-color="white"
                        v-bind="attrs"
                        v-on="on"
                        small
                        label
                      >
                        <p class="m-0 custom-nowrap-ellipsis">
                          {{ formatDate(data.expense_date) }}
                        </p>
                      </v-chip>
                      <em v-else class="text-muted">No date</em>
                    </template>
                    <p class="m-0 custom-nowrap-ellipsis">
                      {{ formatDate(data.expense_date) }}
                      {{ formatTime(data.expense_date) }}
                    </p>
                  </v-tooltip>
                </td>

                <!-- Status Column -->
                <td class="font-size-14 font-weight-500">
                  <CustomStatus
                    v-if="data.status"
                    small
                    :status="parseInt(data.status)"
                    endpoint="claim/status"
                  ></CustomStatus>
                  <span v-else class="text-muted">No Status</span>
                </td>

                <!-- Type Column -->
                <!-- <td class="font-size-14 font-weight-500">
                  <template v-if="data.type">
                    <v-chip
                      small
                      :color="getTypeColor(data.type)"
                      text-color="white"
                      label
                    >
                      {{ data.type }}
                    </v-chip>
                  </template>
                  <em v-else class="text-muted">No Type</em>
                </td> -->

                <!-- Created On Column -->
                <td class="font-size-14 font-weight-500">
                  <TableActivity
                    v-if="!lodash.isEmpty(data.added_by)"
                    :data="data"
                  >
                    <template v-slot:first_letters>
                      {{ getFirstLetters(data.added_by?.display_name) }}
                    </template>
                    <template v-slot:display_name>
                      {{ data.added_by?.display_name }}
                    </template>
                    <template v-slot:date_time>
                      <template v-if="getDateCountAll(data.added_at)">
                        {{ formatDateTime(data.added_at) }}
                      </template>
                      <template v-else>
                        {{ formatDate(data.added_at) }}
                      </template>
                    </template>
                    <template v-slot:format_date_time>
                      {{ formatDate(data.added_at) }}
                      {{ formatTime(data.added_at) }}
                    </template>
                  </TableActivity>
                  <template v-else>
                    <em class="text-muted">No data</em>
                  </template>
                </td>
              </tr>
              <!-- Empty State -->
              <tr v-if="!claims || claims.length === 0">
                <td :colspan="9" class="py-4">
                  <p
                    class="m-0 row-not-found text-center font-weight-500 font-size-16"
                  >
                    <img
                      :src="$assetURL('media/error/empty.png')"
                      class="row-not-found-image"
                    />
                    Uhh... There are no claims for this visit at the moment..
                  </p>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <ListingFooter
      v-if="claims && claims.length"
      :dataLoading="dataLoading"
      :showingFrom="showingFrom"
      :showingTo="showingTo"
      :totalRows="totalRows"
      :currentPage="currentPage"
      :totalPages="totalPages"
      removePage
    ></ListingFooter>
  </div>
</template>

<script>
import Barcode from "@/view/pages/partials/Barcode.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import CustomStatus from "@/view/pages/partials/CustomStatus.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import moment from "moment";

export default {
  name: "VisitClaims",
  mixins: [CommonMixin],
  props: {
    visitId: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    Barcode,
    TableActivity,
    CustomStatus,
    ListingFooter,
  },
  data() {
    return {
      loading: false,
      dataLoading: false,
      claims: [],
      currentPage: 1,
      totalPages: 0,
      totalRows: 0,
      perPage: 10,
      rowsOffset: 0,
    };
  },
  methods: {
    async fetchClaims() {
      try {
        this.loading = true;
        this.dataLoading = true;
        const response = await this.$http.get(`/claims`, {
          params: {
            visit_id: this.visitId,
            per_page: this.perPage,
            current_page: this.currentPage,
          },
        });
        const data = response.data.data || {};
        const allClaims = data.rows || [];
        this.claims = allClaims;
        this.currentPage = data.current_page || 1;
        this.totalRows = data.total_rows || allClaims.length;
        this.perPage = data.per_page || this.perPage;
        this.rowsOffset = data.offset || 0;
        this.totalPages =
          this.perPage > 0 ? Math.ceil(this.totalRows / this.perPage) : 0;
      } catch (error) {
        console.error("Error fetching claims:", error);
        this.$toast.error("Failed to load claims");
      } finally {
        this.loading = false;
        this.dataLoading = false;
      }
    },

    getTypeColor(type) {
      switch (type) {
        case "Visit":
          return "blue";
        case "Customer":
          return "green";
        case "Lead":
          return "orange";
        default:
          return "grey";
      }
    },

    // ✅ LOCAL DATE FORMATTING METHODS ✅
    /**
     * Format datetime to relative time like "19 min ago", "2 hours ago"
     */
    formatDateTime(dateTime) {
      if (!dateTime) return "-";
      return moment(dateTime).fromNow();
    },

    /**
     * Format date like "16 Oct 2025"
     */
    formatDate(dateTime) {
      if (!dateTime) return "-";
      return moment(dateTime).format("DD MMM YYYY");
    },

    /**
     * Format time like "11:46 AM"
     */
    formatTime(dateTime) {
      if (!dateTime) return "-";
      return moment(dateTime).format("hh:mm A");
    },

    getDateCountAll(dateTime) {
      if (!dateTime) return false;
      const now = moment();
      const date = moment(dateTime);
      const diffInDays = now.diff(date, "days");
      return diffInDays <= 7;
    },

    handlePaginationUpdate(page) {
      if (!page || page === this.currentPage) {
        return;
      }
      this.currentPage = page;
      this.fetchClaims();
    },
  },
  computed: {
    showingFrom() {
      return this.lodash.isEmpty(this.claims) === false
        ? this.rowsOffset + 1
        : 0;
    },
    showingTo() {
      return this.rowsOffset + (this.claims ? this.claims.length : 0);
    },
  },
  mounted() {
    if (this.$route?.query?.page) {
      this.currentPage = Number(this.$route.query.page);
    }
    PaginationEventBus.$on("update:pagination", this.handlePaginationUpdate);
  },
  beforeDestroy() {
    PaginationEventBus.$off("update:pagination", this.handlePaginationUpdate);
  },
  watch: {
    visitId: {
      immediate: true,
      handler() {
        if (this.visitId) {
          this.fetchClaims();
        }
      },
    },
  },
};
</script>

<style scoped>
.visit-claims {
  width: 100%;
}

.v-data-table .v-data-table__wrapper {
  overflow-x: auto;
}

.v-data-table .v-data-table__empty-wrapper {
  padding: 20px 0;
}
</style>
